import {useLocation, useNavigate} from "react-router-dom";
import {useEffect} from "react";
import {wrappedFetch} from "component/const/Functions";
import {getUserId} from "component/const/ForAuth";
import {restUrl} from "../../../apiUrl";

export default function Apply() {
    const location = useLocation();
    const {testId} = location.state;
    const navigate = useNavigate();
    useEffect(() => {
        hah()
    }, []);
    const hah = async () => {
        // eslint-disable-next-line no-restricted-globals
        const confirmRes = window.confirm("접수하시겠습니까?");
        if (confirmRes) {
            const id = await getUserId();
            wrappedFetch('/activity_test_application', {
                method: 'POST',
                body: JSON.stringify({
                    instance_id: testId,
                    user_id: id,
                })
            }, restUrl).then(() => navigate(-1))
        } else {
            navigate(-1)
        }
    }
}